import React from 'react'
import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroller'
import PromoCard from './PromoCard'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import { CheckoutAddressConsumer } from '../CheckoutAddressProvider/CheckoutAddressProvider'
import Loader from '../Loader/Loader'
import { impressionTypes } from '../../lib/impressionsTracker'
import { usePromoImpressionTracker } from '../Recipe/recipeUtils'
import BannerCarouselWrapper from './BannerCarouselWrapper'

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  li {
    border: solid 1px #eaeaea;
  }
`
const Header = styled.div``

const HeaderTitle = styled.div`
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: bold;
  padding: 1rem 0 1.5rem;
`

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 0;
`

const PromoList = ({
  items,
  loadMore,
  hasMore,
  label,
  pageType,
  ctaLocationMeta,
  track,
  trackSplit,
  checkoutAddress,
  bannerInfo,
}) => {
  const { createObserver, trackImpressions } = usePromoImpressionTracker({
    track,
    trackSplit,
    checkoutAddress,
    impressionType: impressionTypes.WEEKLY_PROMO_IMPRESSION,
    meta: {
      trackInfo: {
        promotion_id: 'grocery-online | weekly promotions | all',
        promotion_name: 'listing | weekly promotions',
        isGA4Promo: true,
      },
    },
  })
  return (
    <>
      <Header>
        <HeaderTitle data-testid="weekly-deals">Weekly promotions</HeaderTitle>
      </Header>
      <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={hasMore}
        loader={
          <LoaderContainer id="recipe-list-loader">
            <Loader />
          </LoaderContainer>
        }
      >
        <BannerCarouselWrapper
          imageList={bannerInfo}
          storeType={checkoutAddress?.storeType}
        />

        <List>
          {items.map((item, index) => (
            <PromoCard
              key={item.isin}
              item={item}
              pageType={pageType}
              bannerPosition={index + 1}
              track={track}
              label={label}
              sectionTitle={label}
              trackImpressions={trackImpressions}
              createObserver={createObserver}
              ctaLocationMeta={ctaLocationMeta}
            />
          ))}
        </List>
      </InfiniteScroll>
    </>
  )
}

const PromoListWrp = props => (
  <CheckoutAddressConsumer>
    {({ checkoutAddress }) => (
      <EventTrackingConsumer>
        {({ track, trackSplit }) => (
          <PromoList
            {...props}
            track={track}
            trackSplit={trackSplit}
            checkoutAddress={checkoutAddress}
          />
        )}
      </EventTrackingConsumer>
    )}
  </CheckoutAddressConsumer>
)

export default PromoListWrp
